const map = {
  skipFont: ({ theme }) => theme.fonts.set(`primary`, `semibold`),
  skipForeground: ({ theme }) => theme.colors.white,
  skipBackground: ({ theme }) => theme.colors.black,
}

export default map
